<!--
    Activity List Item: Contact Info
    - Class: activity-type--contact-info
    - Event names:
      - create_{phone_number|email|address}_{home|work}
      - update_{phone_number|email|address}_{home|work}
      - update_{phone_number|email|address}_{home|work}_{confirmed|bad}
      - subscribe_{phone_number|email}_{home|work}
      - unsubscribe_{phone_number|email}_{home|work}
    - Description: The format/layout for creating and updating phone numbers, emails, and addresses is the same;
      specific activities are differentiated by `div.details` content
    -->

<div class="ab-list-item-inner flex w-100 activity-type--contact-info">
  <span class="ab-list-item__icon">
    <i class="icon fal"
       [ngClass]="iconClass"></i>
  </span>
  <div class="ab-list-item__content">
    <div class="summary">
      <span class="actor">{{item?.user?.name}}</span>
      {{getEventDescriptionText(item)}}
      <app-activity-target-link [target]="item.target">{{item.target | fullName}}</app-activity-target-link>
    </div>
    <div class="details">
      <span class="tag"
            *ngIf="item.itemType == 'Email'">Email</span>
      <span class="tag"
            *ngIf="item.itemType == 'PhoneNumber'">Phone</span>
      <span class="tag"
            *ngIf="item.itemType == 'Address'">Address</span>
      <span class="tag"
            *ngIf="item.itemType == 'SocialProfile'">Social Media Profile</span>

      <span class="tag-type meta ml-0025"
            *ngIf="item.itemType == 'Email' || item.itemType == 'PhoneNumber' || item.itemType == 'SocialProfile'">({{
        item.itemType == 'SocialProfile' ?
        item.payload?.socialProfile?.label
        :
        getHomeWorkMobile(item.name)}})</span>:

      <strong class="response"
              [ngSwitch]="item.itemType">
        <span *ngSwitchCase="'Address'">{{item.payload?.address | address}}</span>
        <span *ngSwitchCase="'Email'">{{item.payload?.email?.email}}</span>
        <span *ngSwitchCase="'PhoneNumber'">{{item.payload?.phoneNumber?.number | phone}}</span>
        <span *ngSwitchCase="'SocialProfile'">
          {{item.payload?.socialProfile?.profile}}
        </span>
      </strong>


      <span class="response-status meta ml-0050"
            *ngIf="getPayload()?.status === 'verified'">
        <i class="far fa-check pair__verified"
           matTooltip="Confirmed"
           matTooltipPosition="left"></i>
      </span>
      <span class="response-status meta ml-0050"
            *ngIf="getPayload()?.status === 'do_not_contact'">
        <i class="far fa-ban color--red"
           matTooltip="Do not contact"
           matTooltipPosition="left"></i>
      </span>
      <span class="response-status meta ml-0050"
            *ngIf="getPayload()?.status === 'bad'">
        <i class="far fa-times-circle color--red"
           matTooltip="Marked as Bad"
           matTooltipPosition="left"></i>
      </span>
      <span class="response-status meta ml-0050"
            *ngIf="getPayload()?.subscribed">
        <i class="far fa-bell-on pair__verified"
           matTooltip="Subscribed"
           matTooltipPosition="left"></i>
      </span>

    </div>
  </div>
  <app-activity-event-timestamp [item]="item"
                                class="ab-list-item__timestamp">
  </app-activity-event-timestamp>
</div>
